// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type=\"checkbox\"][data-v-4c4d23a6] {\n  margin: 2px 2px 2px 8px;\n}\n", ""]);
// Exports
module.exports = exports;
